type OperatorSessionLogoutHandler = () => Promise<unknown>;

let operatorSessionLogoutHandler: OperatorSessionLogoutHandler | null = null;

/**
 * Keeps the primary auth store independent from the operator HTTP service.
 * The app-wide lifecycle registers the best-effort revoker after startup.
 */
export function registerOperatorSessionLogoutHandler(
  handler: OperatorSessionLogoutHandler
): () => void {
  operatorSessionLogoutHandler = handler;

  return () => {
    if (operatorSessionLogoutHandler === handler) operatorSessionLogoutHandler = null;
  };
}

export async function revokeOperatorSessionBeforePrimaryLogout(): Promise<void> {
  await operatorSessionLogoutHandler?.();
}
